export const Button = ({
  children,
  onClick,
  variant = "primary",
  size = "medium",
  icon: Icon,
  fullWidth = false,
  disabled = false,
  className = "",
  ...props
}) => {
  const baseStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "background-color 150ms",
    gap: "4px",
    fontFamily: "inherit",
  };

  const sizeStyles = {
    small: { padding: "6px 12px" },
    medium: { padding: "8px 16px" },
    large: { padding: "12px 24px" },
  };

  const variantStyles = {
    primary: {
      backgroundColor: "var(--primary, #ff5a00)",
      color: "var(--background, #ffffff)",
      borderBottom: "4px solid #b13b0d",
      "&:hover": { backgroundColor: "#e65100" },
      "&:disabled": {
        backgroundColor: "#ff8c66",
        cursor: "not-allowed",
      },
    },
    outline: {
      backgroundColor: "transparent",
      color: "var(--text, #000000)",
      borderTop: "1px solid #d1d5db",
      borderLeft: "1px solid #d1d5db",
      borderRight: "1px solid #d1d5db",
      borderBottom: "3px solid var(--gray)",
      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
      "&:disabled": {
        color: "#9CA3AF",
        borderColor: "#E5E7EB",
        cursor: "not-allowed",
      },
    },
    ghost: {
      backgroundColor: "transparent",
      color: "var(--text, #000000)",
      border: "none",
      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.05)" },
      "&:disabled": {
        color: "#9CA3AF",
        cursor: "not-allowed",
      },
    },
  };

  const widthStyle = fullWidth ? { width: "100%" } : {};

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        ...baseStyles,
        ...sizeStyles[size],
        ...variantStyles[variant],
        ...widthStyle,
        ...props.style,
      }}
      className={className}
      onMouseEnter={(e) => {
        if (!disabled && variantStyles[variant]["&:hover"]) {
          e.currentTarget.style.backgroundColor =
            variantStyles[variant]["&:hover"].backgroundColor;
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor =
            variantStyles[variant].backgroundColor;
        }
      }}
      {...props}
    >
      {Icon && <Icon size={16} />}
      {children}
    </button>
  );
};
